import React from 'react';
import Page from 'components/Page/Page';

const NotFoundPage = () => {
    return (
        <Page.Error>
            Page not Found
        </Page.Error>
    )
};

export default NotFoundPage;
